/* Native details remain usable without JS; initialise each footer once. */
(() => {
  if (window.novaFooterServiceLoaded) return;
  window.novaFooterServiceLoaded = true;

  function initialise(root) {
    root.querySelectorAll('[data-nova-footer]').forEach((footer) => {
      if (footer.dataset.novaFooterReady) return;
      footer.dataset.novaFooterReady = 'true';
      const mobile = window.matchMedia('(max-width: 749px)');
      const menus = Array.from(footer.querySelectorAll('[data-nova-footer-menu]'));
      const newsletter = footer.querySelector('[data-nova-footer-newsletter]');
      const form = footer.querySelector('.nova-footer__form');
      const url = new URL(location.href);
      const ownResponse = !!form && url.hash === `#${form.id}` &&
        !url.searchParams.has('nova_signup') &&
        (!url.searchParams.has('footer_newsletter') || url.searchParams.get('footer_newsletter') === '1');
      const messages = Array.from(footer.querySelectorAll('[data-nova-footer-feedback]'));
      messages.forEach(message => { message.hidden = !ownResponse; });
      const feedback = ownResponse ? messages.find(message => message.getAttribute('role') === 'alert') || messages[0] : null;
      const email = form?.querySelector('[type="email"]');
      email?.removeAttribute('aria-invalid');
      email?.removeAttribute('aria-describedby');
      if (feedback && email) {
        email.setAttribute('aria-describedby', feedback.id);
        if (feedback.getAttribute('role') === 'alert') email.setAttribute('aria-invalid', 'true');
      }
      const brandCopy = footer.querySelector('.nova-footer__brand-copy');
      let lastMobile = mobile.matches;
      let hadMainNewsletter = false;

      function updateNewsletterVisibility() {
        if (!newsletter) return;
        const candidate = document.querySelector('#MainContent .nova-nl__form');
        hadMainNewsletter = !!(candidate && candidate.getClientRects().length);
        newsletter.hidden = footer.dataset.hideHomeNewsletter === 'true' && hadMainNewsletter && !feedback;
        if (brandCopy) brandCopy.hidden = !newsletter.hidden;
        footer.classList.toggle('nova-footer--with-newsletter', !newsletter.hidden);
      }
      function syncDetails(resetMobile = false) {
        menus.forEach((menu) => {
          menu.open = !mobile.matches;
          const summary = menu.querySelector('summary');
          summary.tabIndex = mobile.matches ? 0 : -1;
        });
        if (newsletter) newsletter.open = !mobile.matches || !!feedback;
        lastMobile = mobile.matches;
      }
      updateNewsletterVisibility();
      syncDetails();
      mobile.addEventListener('change', () => {
        if (mobile.matches !== lastMobile) syncDetails(true);
      });
      footer.querySelectorAll('details').forEach((details) => {
        // Use native accessibility states. Escape closes a mobile disclosure and returns focus.
        details.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && mobile.matches && details.open) {
            details.open = false;
            details.querySelector('summary').focus();
            event.stopPropagation();
          }
        });
      });
      const returnTo = form?.querySelector('input[name="return_to"]');
      if (returnTo) {
        const destination = new URL(window.location.href);
        destination.searchParams.delete('customer_posted');
        destination.searchParams.delete('nova_signup');
        destination.searchParams.set('footer_newsletter', '1');
        destination.hash = form.id;
        returnTo.value = destination.pathname + destination.search + destination.hash;
      }
      const back = footer.querySelector('[data-nova-footer-top]');
      if (back) {
        back.hidden = false;
        back.addEventListener('click', () => {
          const main = document.getElementById('MainContent');
          if (main) main.focus({ preventScroll: true });
          window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      }
      if (feedback) {
        newsletter.hidden = false;
        newsletter.open = true;
        feedback.focus();
      }
      const onSectionChange = () => {
        if (!footer.isConnected) {
          document.removeEventListener('shopify:section:load', onSectionChange);
          document.removeEventListener('shopify:section:unload', onSectionChange);
          return;
        }
        updateNewsletterVisibility();
      };
      document.addEventListener('shopify:section:load', onSectionChange);
      document.addEventListener('shopify:section:unload', onSectionChange);
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', () => initialise(document));
})();
